import type { KeyboardEvent } from 'react';

/**
 * Enter and Space on a `role="button"` row, which the browser handles for real
 * `<button>`s and for nothing else. The navigator's rows can't be buttons —
 * scope, group and task rows all carry buttons of their own, and a button
 * inside a button is invalid HTML — so selection is wired up by hand.
 *
 * Keys pressed on anything nested inside the row are left alone: a Space on the
 * approve control or the expand caret belongs to that control, and would
 * otherwise both press it and select the row.
 */
export const selectRowOnEnterOrSpace = (select: () => void) => (event: KeyboardEvent<HTMLElement>) => {
  if (event.target !== event.currentTarget) return;
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  select();
};
